const TURKISH_AREA_CODES = new Set([
  '212', '216', '222', '224', '226', '228', '232', '236', '238', '242', '246', '248',
  '252', '256', '258', '262', '264', '266', '272', '274', '276', '282', '284', '286',
  '288', '312', '318', '322', '324', '326', '328', '332', '338', '342', '344', '346',
  '348', '352', '354', '356', '358', '362', '364', '366', '368', '370', '372', '374',
  '376', '378', '380', '382', '384', '386', '388', '392', '412', '414', '416', '422',
  '424', '426', '428', '432', '434', '436', '438', '442', '446', '452', '454', '456',
  '458', '462', '464', '466', '472', '474', '476', '478', '482', '484', '486', '488',
  '800', '811', '822', '850', '888', '898', '900',
])

const isTurkishMobilePrefix = (prefix: string) => /^(50[1567]|510|512|516|53\d|54\d|55[123459]|561|57[0-5]|592|594)$/.test(prefix)
const isTurkishNationalNumber = (digits: string) => digits.length === 10
  && (isTurkishMobilePrefix(digits.slice(0, 3)) || TURKISH_AREA_CODES.has(digits.slice(0, 3)))

/**
 * Returns digits in international form without a leading plus sign.
 * Explicit +/00 country codes are always preserved. An unmarked 10-digit
 * number receives 90 only when its prefix is recognizably Turkish.
 */
export const normalizePhoneNumberValue = (value: unknown) => {
  const raw = String(value ?? '').trim()
  if (!raw) return ''

  const explicitInternational = raw.startsWith('+') || /^00(?:\s|\d)/.test(raw)
  let digits = raw.replace(/\D/g, '')
  if (!digits) return ''

  if (explicitInternational) {
    if (digits.startsWith('00')) digits = digits.slice(2)
    return digits
  }

  if (digits.startsWith('0')) digits = digits.slice(1)
  if (digits.length === 12 && digits.startsWith('90')) return digits
  if (isTurkishNationalNumber(digits)) return `90${digits}`
  return digits
}
